import {useAPIData} from '../context/hooks/useAPIData'

const TrackingLink = (props) => {
    const data = useAPIData()
    const isPrincessAgent = data.princessAgent
    let urlParameters = window.location.href.split('?')[1];
    if (urlParameters === undefined) {
        urlParameters = '';
    }
    const href = props.href.toString();
    const mobileSettings = isPrincessAgent ? {onClick: (e) => {e.preventDefault()}} : {}
    let customHref = href
    if (href.indexOf('princesscasino.ro') !== -1) {
        if (urlParameters.length >0 ) {
            if (href.indexOf('?') === -1){
                customHref = href + '?' + urlParameters
            } else {
                customHref = href + '&' + urlParameters
            }
        }
    }
    return <a className={(isPrincessAgent ? 'tracking-button ' : '') + props.className} {...props} href={customHref} {...mobileSettings}>{props.children}</a>
};

export default TrackingLink;
